/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Button } from 'react-bootstrap';

import {
  TextField,
} from 'ui/FormElement';

import { FieldArray } from 'formik';
import deleteIcon from 'images/icons/invite/delete.svg';
import DescriptionGroupItems from './DescriptionGroupItems';

function DescriptionGroups({
  parentName, collection, helpers, isReadonly,
}) {
  const { remove, push } = helpers;

  return (
    <div>
      {collection.map(
        (item, index) => (
          <div key={index}>
            <Row>
              <Col md={10}>
                <TextField
                  name={`${parentName}.${index}.name`}
                  placeholder="Group Name"
                  disabled={isReadonly}
                />
              </Col>

              {!isReadonly && (
              <Col md={2} className="text-right">
                <Button bsStyle="link" onClick={() => remove(index)}>
                  <img src={deleteIcon} alt="delete" />
                </Button>
              </Col>
              )}
            </Row>
            <FieldArray name={`${parentName}[${index}].items`}>
              {(itemHelpers) => (
                <DescriptionGroupItems
                  parentName={`${parentName}.${index}.items`}
                  helpers={itemHelpers}
                  collection={item.items}
                  isReadonly={isReadonly}
                />
              )}
            </FieldArray>
          </div>
        ),
      )}
      {!isReadonly && (
      <div className="text-right">
        <Button
          onClick={() => push({
            name: '',
            items: [],
          })}
          bsStyle="primary"
        >
          Add Group
        </Button>
      </div>
      )}
    </div>
  );
}

export default DescriptionGroups;

DescriptionGroups.propTypes = {
  parentName: PropTypes.string.isRequired,
  helpers: PropTypes.object.isRequired,
  collection: PropTypes.arrayOf(PropTypes.object),
  isReadonly: PropTypes.bool,
};

DescriptionGroups.defaultProps = {
  collection: [],
  isReadonly: false,
};
